import React, { useState } from "react";
import Profile from "../../assets/img/f1.jpg";
import axios from "axios";
import MatchPopup from "./MatchPopup";

const RequestCard = ({ data, getData, user, handleAlert }) => {
  const [messageModal, setMessageModal] = useState(false)
  const accept_request = async (id) => {
    const url = localStorage.getItem("api_url");
    axios({
      method: "post",
      url: url + "accept_request/" + id,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const response = res.data;
      if (response.status != true) {
        handleAlert(true, "Failed", response.message, null, false);
        getData();
      } else {
        setMessageModal(true)
      }
    });
  };

  const rejectRequest = (request) => {
    const formdata = new FormData();
    formdata.set("request_id", request.request_id);
    formdata.set("sender_acceptance", request.sender_id);
    formdata.set("receiver_rejection", user.rejection_code);

    const url = localStorage.getItem("api_url");

    axios({
      method: "post",
      url: url + "reject_request",
      data: formdata,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const response = res.data;
      console.log(response);
      if (response.status != true) {
        handleAlert(
          true,
          "Reject Request Failed",
          response.message,
          null,
          false
        );
        getData();
      } else {
        handleAlert(true, "Rejected succesfully", response.message, null, true);
        getData();
      }
    });
  };
  return (
    <div className="card-container">
      {/**IMAGE CONTAINER */}
      <div className="img-container">
        <img
          src={`https://services.hitasoft.in/braxelet/uploads/user/${
            data.sender.profile_image
              ? data.sender.profile_image
              : "default_user.png"
          }`}
          alt="Profile Image"
          className="img-profile"
        />
      </div>

      {/**IMAGE CONTENT */}
      <div className="card-content">
        {/**USER DETAILS */}
        <p className="paragraph">
          <span className="heading-tertiary profile-name">
            {data.sender.name}
          </span>{" "}
          wants to be your Friend.
        </p>

        {/**ACTION BUTTONS */}
        <div className="card-button-row">
          <button
            className="card-button btn-no"
            onClick={() => rejectRequest(data)}
          >
            No
          </button>
          <button
            className="card-button btn-yes"
            onClick={() => accept_request(data.request_id)}
          >
            Yes
          </button>
        </div>
      </div>
      <MatchPopup openModal={messageModal} user={user} friend={data.sender} getdata={getData}/>
    </div>
  );
};

export default RequestCard;
